/**
 * Crossfade gain curve (PRD §4.6.3 rule 8 — «плавный переход», preset
 * `crossfade_seconds` 0–12, default 3).
 *
 * The player runs a single `<audio>` element, so the "crossfade" is realised
 * as sequential volume ramps: linear fade-in over the first `fadeSec` seconds
 * and linear fade-out over the last `fadeSec` seconds of the track. The
 * returned gain multiplies the user's volume; it never exceeds 1.
 *
 * Edge cases:
 *   - `fadeSec <= 0` → always 1 (fade disabled).
 *   - unknown duration (`durationSec <= 0`, e.g. manifest not parsed yet) →
 *     fade-in only; the fade-out ramp needs a known track end.
 *   - track shorter than `2 * fadeSec` → the two ramps overlap; the minimum
 *     of both applies, producing a low triangle rather than a plateau.
 */
export function fadeGain(positionSec, durationSec, fadeSec) {
    if (fadeSec <= 0)
        return 1;
    let gain = 1;
    if (positionSec < fadeSec) {
        gain = Math.min(gain, Math.max(0, positionSec) / fadeSec);
    }
    if (durationSec > 0) {
        const remaining = durationSec - positionSec;
        if (remaining < fadeSec) {
            gain = Math.min(gain, Math.max(0, remaining) / fadeSec);
        }
    }
    return Math.min(1, Math.max(0, gain));
}
//# sourceMappingURL=fade.js.map